// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ht_R","rootMobile":"styles_rootMobile__1l04I"};